type ArticleMediaSource =
  | { src: string; cdnKey?: never }
  | { src?: never; cdnKey: string };

export type ArticleHero =
  | ({ type: 'image' } & ArticleMediaSource)
  | ({ type: 'video'; poster?: string } & ArticleMediaSource)
  | { type: 'youtube'; videoId: string };

export interface ArticleMeta {
  title: string;
  subtitle?: string;
  summary?: string;
  author?: string;
  category: string;
  date: string;
  hero?: ArticleHero;
  slug: string;
}

export const CATEGORY_LABELS: Record<string, string> = {
  api: 'API',
  'case-study': 'Case Study',
  'idea': 'Ideas',
  'workflow': 'Workflows',
  'research': 'Research',
};
